"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjudicationContextSchema = exports.RosterSignalSchema = exports.ContestedValueSchema = exports.AnchorStandingSchema = exports.SerializedAssertionProvenanceSchema = exports.AdjudicationRowSchema = void 0;
const z = require("zod");
const consensus_types_1 = require("../../../../Consensus/consensus.types");
const adjudication_request_types_1 = require("../../../../PackageDataAdjudication/adjudication-request.types");
const package_data_adjudication_types_1 = require("../../../../PackageDataAdjudication/package-data-adjudication.types");
const json_value_1 = require("../../../../Utils/json-value");
exports.AdjudicationRowSchema = z.object({
    rowKey: z.string(),
    values: z.record(z.string(), json_value_1.JsonValueSchema),
});
exports.SerializedAssertionProvenanceSchema = z.object({
    statementId: z.string(),
    adjudicatedByUserId: z.string(),
    adjudicatedAt: z.string(),
    comment: z.string().nullable(),
    planId: z.string().nullable(),
    clauses: package_data_adjudication_types_1.ClauseCitationSchema.array(),
});
exports.AnchorStandingSchema = z.object({
    anchor: consensus_types_1.AnchorSchema,
    status: package_data_adjudication_types_1.GroundTruthStandingStatusSchema,
    groundTruthDatum: package_data_adjudication_types_1.AnchoredDatumSchema.nullable(),
    provenance: exports.SerializedAssertionProvenanceSchema.nullable(),
});
exports.ContestedValueSchema = z.object({
    anchor: consensus_types_1.AnchorSchema,
    proposed: package_data_adjudication_types_1.AnchoredDatumSchema,
    sourceKind: adjudication_request_types_1.AdjudicationSourceKindSchema.optional(),
    sourceRef: z.string().optional(),
    concern: z.string().optional(),
});
exports.RosterSignalSchema = z.object({
    signalId: z.string(),
    name: z.string(),
});
exports.AdjudicationContextSchema = z.object({
    packageName: z.string(),
    manufacturerPartNumber: z.string(),
    manufacturerName: z.string(),
    datasheetFileId: z.string().nullable(),
    packageFamilyId: z.string().nullable().default(null),
});
//# sourceMappingURL=adjudication-view.types.js.map